var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwapIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18,
    r: 18,
    fill: "#0078FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2348 24.5909C19.6094 24.9968 19.5841 25.6294 19.1783 26.004L15.6783 29.2348C15.2953 29.5884 14.7048 29.5884 14.3218 29.2348L10.8217 26.004C10.4159 25.6294 10.3906 24.9968 10.7652 24.591C11.1398 24.1851 11.7724 24.1598 12.1783 24.5344L14 26.216L14 16.5C14 15.9477 14.4477 15.5 15 15.5C15.5523 15.5 16 15.9477 16 16.5L16 26.216L17.8217 24.5344C18.2275 24.1598 18.8602 24.1851 19.2348 24.5909Z",
    fill: "#F4F5F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7652 11.4091C17.3906 11.0032 17.4159 10.3706 17.8217 9.99597L21.3217 6.7652C21.7047 6.4116 22.2952 6.4116 22.6782 6.76519L26.1783 9.99596C26.5841 10.3706 26.6094 11.0032 26.2348 11.409C25.8602 11.8149 25.2276 11.8402 24.8217 11.4656L23 9.78397L23 19.5C23 20.0523 22.5523 20.5 22 20.5C21.4477 20.5 21 20.0523 21 19.5L21 9.784L19.1783 11.4656C18.7725 11.8402 18.1398 11.8149 17.7652 11.4091Z",
    fill: "#F4F5F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIcon);
export default __webpack_public_path__ + "static/media/SwapIcon.2b9cc60d.svg";
export { ForwardRef as ReactComponent };